import React from 'react';
import { View, colors, Heading } from '@fairygodboss/ui';
import { useEventRegistration } from '../EventRegistrationContext';
import { GridColumnWrapper } from './GridColumnWrapper';
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

export const Employer = ({ employer }) => {
    const { image, companyId, companyUrl, longName, name } = employer;

    const src = buildImagePath(image?.src, 'img', {
        img: 'c_scale,f_auto,q_auto,w_270',
    });

    const onEmployerClick = () => {
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'vcf-sponsor-logo-click',
            company_id: [companyId],
        });
        window.open(companyUrl, '_blank');
    };

    return (
        <View
            width={{ _: '50%', sm: '33%', md: '20%' }}
            boxSizing="border-box"
            padding={{ _: '8px', md: '12px' }}
            pb={{ _: '40px', sm: '48px', md: '48px' }}
            css={{
                button: {
                    all: 'unset',
                    cursor: 'pointer',
                    outline: 'none !important',
                },
            }}
        >
            <View as="button" onClick={onEmployerClick}>
                <View
                    borderRadius="12px"
                    overflow="hidden"
                    boxShadow="0px 4px 8px rgba(53, 53, 53, 0.2)"
                    css={{ aspectRatio: '1/1' }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                >
                    <View as="img" src={src} alt={image.alt} width="100%" />
                </View>

                <View display="flex" justifyContent="center">
                    <Heading textAlign="center" pt="16px" variant="headingXs">
                        {longName || name}
                    </Heading>
                </View>
            </View>
        </View>
    );
};

export const ParticipatingEmployers = () => {
    const { participatingEmployers, event } = useEventRegistration();
    const { eventType } = event;
    return participatingEmployers.length && eventType !== 'Webinar' ? (
        <GridColumnWrapper
            backgroundColor={colors.secondary[5]}
            gridAlignment="center"
            px={{ _: '16px', sm: '0px', md: '24px', lg: '0px' }}
            pb={{ _: '16px', sm: '0px', md: '16px' }}
            gridColumnSpacing={{ xs: 12, sm: 9, md: 10, lg: 10 }}
        >
            <View pt={{ _: '32px', md: '56px' }}>
                <Heading
                    pb={{ _: '24px', md: '40px' }}
                    fontWeight="700"
                    variant={{
                        _: 'headingSm',
                        sm: 'headingMd',
                        md: 'headingLg',
                    }}
                    as="h2"
                >
                    Participating Employers
                </Heading>
            </View>
            <View
                display="flex"
                flexWrap="wrap"
                mx={{ _: '-8px', md: '-12px' }}
            >
                {participatingEmployers.map((e) => (
                    <Employer employer={e} key={e?.companyId} />
                ))}
            </View>
        </GridColumnWrapper>
    ) : null;
};

ParticipatingEmployers.displayName = 'ParticipatingEmployers';
